import React from 'react';
import '../styles/skeleton.css'

const ProductSkeleton = () => {
  return (
    <div className="item-card-skeleton">
      {/* Image Placeholder */}
      <div className="skeleton skeleton-image"></div>
      
      {/* Info Placeholder */}
      <div className="item-info-skeleton">
        <div className="skeleton skeleton-line" style={{ width: '50%' }}></div>
        <div className="skeleton skeleton-line" style={{ width: '70%' }}></div>
        <div className="skeleton skeleton-line" style={{ width: '30%' }}></div>
      </div>
      
      {/* Best Price Placeholder */}
      <div className="bestPrice-skeleton">
        <div className="skeleton skeleton-line" style={{ width: '60%' }}></div>
      </div>
      
      {/* Actions Placeholder */}
      <div className="item-actions-skeleton">
        <div className="skeleton skeleton-button"></div>
      </div>
    </div>
  );
};

const CollectionSkeleton = () => {
  return (
    <div>
      <div className="d-flex justify-between align-center bg-1">
        <span className="skeleton skeleton-line" style={{ width: '30%' }}></span>
        <span className="skeleton skeleton-line" style={{ width: '15%' }}></span>
      </div>
      <div className="skeleton-collection-container">
        {Array(6)
          .fill(0)
          .map((_, index) => (
            <ProductSkeleton key={index} />
          ))}
      </div>
    </div>
  );
};
const FooterSkeleton = () => {
  return (
    <div className="fixed-bottom-bar-skeleton">
      <div className="skeleton-footer-icon">
        <div className="skeleton skeleton-circle"></div>
        <div className="skeleton skeleton-line" style={{ width: '50%' }}></div>
      </div>
      <div className="skeleton-footer-icon">
        <div className="skeleton skeleton-circle"></div>
        <div className="skeleton skeleton-line" style={{ width: '60%' }}></div>
      </div>
      <div className="skeleton-footer-icon">
        <div className="skeleton skeleton-circle"></div>
        <div className="skeleton skeleton-line" style={{ width: '50%' }}></div>
      </div>
      <div className="skeleton-footer-icon">
        <div className="skeleton skeleton-circle"></div>
        <div className="skeleton skeleton-line" style={{ width: '40%' }}></div>
      </div>
    </div>
  );
};

const ProductDetailSkeleton = () => {
  return (
    <div className="product-detail-card-skeleton">
      {/* Image Skeleton */}
      <div className="product-image-skeleton">
        <div className="skeleton skeleton-image"></div>
      </div>

      {/* Product Details Skeleton */}
      <div className="product-details-skeleton">
        <div className="skeleton skeleton-line" style={{ width: "70%" }}></div>
        <div className="skeleton skeleton-line" style={{ width: "40%" }}></div>

        <div className="product-detail-price-skeleton">
          <div>
            <div className="skeleton skeleton-line" style={{ width: "50%" }}></div>
            <div className="skeleton skeleton-line" style={{ width: "30%" }}></div>
          </div>
          <div className="skeleton skeleton-line" style={{ width: "20%" }}></div>
        </div>

        <div className="skeleton skeleton-line" style={{ width: "90%" }}></div>
        <div className="skeleton skeleton-line" style={{ width: "80%" }}></div>

        <div className="product-best-price-slabs-skeleton">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="skeleton skeleton-line" style={{ width: "80%" }}></div>
          ))}
        </div>

        <div className="product-icons-skeleton d-flex justify-evenly">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="skeleton skeleton-circle"></div>
          ))}
        </div>

        <div className="skeleton skeleton-line" style={{ width: "60%" }}></div>
        <div className="skeleton skeleton-line" style={{ width: "40%" }}></div>

        <div className="skeleton skeleton-line" style={{ width: "70%" }}></div>
      </div>

      {/* Footer Skeleton */}
      <div className="product-detail-footer-skeleton">
        <div className="skeleton skeleton-button"></div>
        <div className="skeleton skeleton-select"></div>
        <div className="skeleton skeleton-button"></div>
      </div>
    </div>
  );
};


//export default CollectionSkeleton;
export { CollectionSkeleton, FooterSkeleton, ProductDetailSkeleton };
